import { X } from 'lucide-react';
import darkLogo from '@/assets/images/selise_ai_v4.svg';
import lightLogo from '@/assets/images/selise_ai_v4.svg';

interface LogoSectionProps {
  theme: string;
  open: boolean;
  isMobile: boolean;
  onClose: () => void;
}

export const LogoSection = ({ theme, open, isMobile, onClose }: Readonly<LogoSectionProps>) => {
  return (
    <div className="relative h-8  w-full">
      <img
        src={theme === 'dark' ? lightLogo : darkLogo}
        alt="logo"
        className={`absolute left-4 top-1 h-8 w-auto max-w-full duration-300 ${
          open || isMobile ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      />

      {/* Small logo removed from here as it should be shown in the header instead when closed */}

      {isMobile && (
        <button
          className="absolute right-4 top-1/2 transform -translate-y-1/2"
          onClick={onClose}
          aria-label="Close sidebar"
        >
          <X size={20} />
        </button>
      )}
    </div>
  );
};
